var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import tabsNavigation from '../parts/navi-tabs';
function registerPlayer(playerData) {
    return __awaiter(this, void 0, void 0, function* () {
        const API_URL = 'https://prod-game-sweepstakes-api.disney-solitaire.app/register';
        const API_TOKEN = 'WtWDd6YpRmWtKoo7hUzCTvnCCVez2VdXxoCVfjCDmFQ';
        const response = yield fetch(API_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${API_TOKEN}`,
            },
            body: JSON.stringify(playerData),
        });
        if (!response.ok) {
            const error = new Error('API error');
            error.status = response.status;
            throw error;
        }
        return response.json();
    });
}
const initContentTabsBlockWithForm = () => {
    tabsNavigation('.js-content-tab-click', '.js-content-tab');
    document.querySelectorAll('.custom-select').forEach(select => {
        if (select.classList.contains('is-initialized'))
            return;
        select.classList.add('is-initialized');
        const trigger = select.querySelector('.custom-select__trigger');
        const dropdown = select.querySelector('.custom-select__dropdown');
        const input = select.querySelector('input[name="country"]');
        if (!trigger || !dropdown || !input)
            return;
        trigger.addEventListener('click', () => {
            dropdown.classList.toggle('open');
            trigger.classList.toggle('open');
        });
        dropdown.querySelectorAll('.custom-select__option').forEach(option => {
            option.addEventListener('click', () => {
                const value = option.getAttribute('data-value') || '';
                trigger.textContent = value;
                input.value = value;
                dropdown.classList.remove('open');
                trigger.classList.remove('open');
            });
        });
        document.addEventListener('click', (e) => {
            if (!select.contains(e.target)) {
                dropdown.classList.remove('open');
            }
        });
    });
    document.querySelectorAll('.js-registration-form').forEach(form => {
        if (form.classList.contains('is-initialized'))
            return;
        form.classList.add('is-initialized');
        const formEl = form;
        const emailInput = form.querySelector('input[name="email"]');
        const confirmEmailInput = form.querySelector('input[name="confirm_email"]');
        if (emailInput && confirmEmailInput) {
            const validateEmailsMatch = () => {
                var _a;
                const email = emailInput.value.trim();
                const confirmEmail = confirmEmailInput.value.trim();
                const errorBox = (_a = confirmEmailInput.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector('.error-message');
                if (!errorBox)
                    return;
                if (!confirmEmail) {
                    errorBox.textContent = '';
                    return;
                }
                if (email !== confirmEmail) {
                    errorBox.textContent = form.getAttribute('data-msg-email-mismatch') || 'Email addresses do not match';
                }
                else {
                    errorBox.textContent = '';
                }
            };
            confirmEmailInput.addEventListener('input', validateEmailsMatch);
            emailInput.addEventListener('input', validateEmailsMatch);
        }
        form.addEventListener('submit', (e) => __awaiter(void 0, void 0, void 0, function* () {
            e.preventDefault();
            const formData = new FormData(formEl);
            const playerId = formData.get('player_id');
            const firstName = formData.get('first_name');
            const lastName = formData.get('last_name');
            const email = formData.get('email');
            const confirmEmail = formData.get('confirm_email');
            const country = formData.get('country');
            const termsInput = form.querySelector('input[name="terms"]');
            const terms = termsInput === null || termsInput === void 0 ? void 0 : termsInput.checked;
            const messageBox = form.querySelector('.form-message');
            if (!messageBox)
                return;
            const submitBtn = form.querySelector('button[type="submit"]');
            const msgRequired = form.getAttribute('data-msg-required') || 'Please fill in all required fields';
            const msgInvalid = form.getAttribute('data-msg-invalid-email') || 'Invalid email address';
            const msgMismatch = form.getAttribute('data-msg-email-mismatch') || 'Email addresses do not match';
            const msgSuccess = form.getAttribute('data-msg-success') || 'Your registration was submitted successfully. Thank you and good luck!';
            const msgInvalidPlayerId = form.getAttribute('data-msg-invalid_player_id') || 'Invalid player ID';
            const msgAlreadyRegistered = form.getAttribute('data-msg-already_registered') || 'Already registered';
            const msgError = 'Something went wrong, please try again';
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            messageBox.textContent = '';
            console.log({
                firstName,
                lastName,
                email,
                confirmEmail,
                country,
                terms
            });
            if (!playerId || !firstName || !lastName || !email || !confirmEmail || !country || !terms) {
                messageBox.textContent = msgRequired;
                return;
            }
            if (!emailRegex.test(email)) {
                messageBox.textContent = msgInvalid;
                return;
            }
            if (email !== confirmEmail) {
                messageBox.textContent = msgMismatch;
                return;
            }
            messageBox.textContent = 'Submitting...';
            submitBtn.disabled = true;
            try {
                const response = yield registerPlayer({
                    player_id: playerId,
                    first_name: firstName,
                    last_name: lastName,
                    email: email,
                    country: country,
                });
                console.log('API success:', response);
                messageBox.textContent = msgSuccess;
                const formWrapper = form.closest('.block-content-tabs-with-form__form');
                formWrapper === null || formWrapper === void 0 ? void 0 : formWrapper.classList.add('form-success');
            }
            catch (error) {
                console.error('API error:', error);
                const status = error === null || error === void 0 ? void 0 : error.status;
                if (status === 404) {
                    messageBox.textContent = msgInvalidPlayerId;
                }
                else if (status === 409) {
                    messageBox.textContent = msgAlreadyRegistered;
                }
                else {
                    messageBox.textContent = msgError;
                }
            }
            finally {
                submitBtn.disabled = false;
            }
        }));
    });
};
document.addEventListener('DOMContentLoaded', initContentTabsBlockWithForm);
if (window.acf) {
    window.acf.addAction('render_block_preview', initContentTabsBlockWithForm);
}
